import React from 'react';

const EventLog = React.memo(React.forwardRef(function EventLog({
  entries,
  emptyLabel = 'Awaiting activity…',
  className = 'event-log',
  listClassName = 'event-log__list',
  entryClassName = 'event-log__entry',
  emptyClassName = 'event-log__entry event-log__entry--empty',
  onScroll,
  startIndex = 0,
}, ref) {
  const items = entries ?? [];
  const hasItems = items.length > 0;

  return (
    <div className={className} onScroll={onScroll} ref={ref}>
      <ul className={listClassName}>
        {hasItems ? (
          items.map((msg, idx) => (
            <li key={`log-${startIndex + idx}`} className={entryClassName}>{msg}</li>
          ))
        ) : (
          <li className={emptyClassName}>{emptyLabel}</li>
        )}
      </ul>
    </div>
  );
}));

export default EventLog;
